<div class="row row-group" *ngIf="useWebcam">
	<div class="col text-center">
		<div *ngIf="isCameraExist">
			<div class="row">
				<div class="col">
					<div class="d-flex justify-content-center align-items-center">
						<div class="camera-container">
							<!-- <webcam [height]="180" [width]="1000" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
								[switchCamera]="nextWebcamObservable">
							</webcam> -->
							<webcam *ngIf="showWebcam"
								[trigger]="triggerObservable" 
								(imageCapture)="handleImage($event)"
								[switchCamera]="nextWebcamObservable">
							</webcam>
						</div>
					</div>
				</div>
			</div>
			<div class="col mt-1">
				<button class="btn btn-secondary" (click)="takeSnapshot()">{{'TAKE_PICTURE' | translate}}</button>
				<!-- <div class="btn-group">
					<button class="btn btn-secondary" (click)="takeSnapshot()">Take Picture</button>
					<button class="btn btn-secondary" (click)="changeWebCame(true)">Toggle Camera</button>
					<button class="btn btn-secondary" (click)="onOffWebCame()">Switch camera</button>
				</div>  -->
			</div>
		</div>
		<div *ngIf="!isCameraExist" class="col text-center">
			{{'WEBCAM_UNAVAILABLE' | translate}}
		</div>
	</div>
</div>
<div class="row row-group">
	<div class="col">
		<ngx-dropzone (change)="onSetFile($event)" [multiple]="false" accept="image/*">
			<ngx-dropzone-label *ngIf="!file">{{title}}<div class="upload-info">{{'DRAG_AND_DROP' | translate}}</div></ngx-dropzone-label>
			<ngx-dropzone-image-preview *ngIf="file" [removable]="true" (removed)="onFileRemove(file)" [file]="file">
				<!-- <ngx-dropzone-label *ngIf="file">{{ file.name }} ({{ file.type }})</ngx-dropzone-label>	 -->
			</ngx-dropzone-image-preview>
			
		</ngx-dropzone>
	</div>
</div>

